import { useState } from "react";
import { BasketDetail } from "../../../../explorer/types/Basket/BasketDetail";
import BasketTotalPrice from "../../../pages/BasketPage/BasketTotalPrice";
import useLanguages from "../../../../explorer/hooks/useLanguages";
import { BoxSummaryBasketStyled, IconsArrowStyled } from "./CollapsibleBasketDetails.style";
import { BasketOfferOrderDetail } from "./BasketOfferOrderDetail";

type CollapsibleBasketDetailsProps = {
    typeSubmit: "ORDER" | "OFFER" | "ORDER_FROM_OFFER";
    currency?: string;
    showDiscount?: boolean;
    prices: any;
    items: any;
    basketDetail?: BasketDetail;
    onSubmitItemNote?: any;
    getItemNote?: any;
};

export const CollapsibleBasketDetails: React.FC<CollapsibleBasketDetailsProps> = (
    props
) => {
    const { currentLanguage } = useLanguages();
    const [lang, setLang] = useState<string>(currentLanguage);
    
    const [collapsed, setCollapsed] = useState(false);
    return (
        <>
            <BoxSummaryBasketStyled
             onClick={() => {
                setCollapsed(!collapsed);
            }}>
                <BasketTotalPrice
                    currency={props.currency}
                    showDiscount={props.showDiscount}
                    fullTotal={props.prices.fullTotal}
                    netTotal={props.prices.netTotal}
                    discount={props.prices.discount}
                    hidePrice={props.prices.hidePrice}
                    collapsed={collapsed}
                />
                <div
                   
                    style={{
                        flex: "0 0 auto",
                       
                        paddingRight: 20,
                        paddingLeft: 7,
                        cursor: "pointer",
                    }}
                >
                    <IconsArrowStyled direction={collapsed ? "down" : "up"} />
                </div>
                <br />
            </BoxSummaryBasketStyled>
            {collapsed && (
                <BasketOfferOrderDetail
                    items={props.items}
                    onSubmitItemNote={props.onSubmitItemNote}
                    getItemNote={props.getItemNote}
                    typeSubmit={props.typeSubmit}
                />
            )}
        </>
    );
};

